import axios from '~/utils/axiosInstance';
import { CreateRfiRequest } from '~/types/requestForInformation';

const baseUrl = '/request-for-information';

export const indexRfisByPortfolioId = async function (portfolioId: string) {
    const response = await axios.get(baseUrl + '/portfolio/' + portfolioId);
    return response.data;
};

export const indexRfisByProjectId = async function (projectId: string) {
    const response = await axios.get(baseUrl + '/project/' + projectId);
    return response.data;
};

export const createRfi = async function (request: CreateRfiRequest) {
   const response = await axios.post(baseUrl, request);
   return response.data;
};

export const updateRfi = async function (rfiId: string, updateData: any) {
    const response = await axios.patch(baseUrl + '/' + rfiId, updateData);
    return response.data;
};

export const deleteRfi = async function (rfiId: string) {
    const response = await axios.delete(baseUrl + '/' + rfiId);
    return response.data;
};
export const createRfiResponse = async function (rfiId: string, responseData: any) {
    const response = await axios.post(baseUrl + '/' + rfiId + '/response', responseData);
    return response.data;
};

export const updateRfiResponse = async function (responseId: string, responseData: any) {
    const response = await axios.patch(baseUrl + '/response/' + responseId, responseData);
    return response.data;
};

export const deleteRfiResponse = async function (responseId: string) {
    const response = await axios.delete(baseUrl + '/response/' + responseId + '/');
    return response.data;
};
